<template>
    <b-navbar type="light" variant="light" class="mb-4 mb-md-0" toggleable="md">
        <b-navbar-toggle class="bg-secondary text-white" target="nav-main"><i class="fa fa-bars"></i></b-navbar-toggle>
        <b-navbar-brand>
            <img src="/static/img/brand/logo.png" alt="Faro logo" class="img-responsive d-inline-block align-top" id="logo">
        </b-navbar-brand>
        <b-collapse is-nav id="nav-main" class="text-center text-md-left">
            <b-navbar-nav class="ml-auto d-block d-md-none" >
                <b-nav-item>
                    <router-link to="/">Start</router-link>
                </b-nav-item>
                <b-nav-item>
                    <router-link :to="{ name: 'products'}">Producten</router-link>
                </b-nav-item>
                <b-nav-item>
                    <router-link :to="{ name: 'terms'}">Voorwaarden</router-link>
                </b-nav-item>
                <b-nav-item>
                    <router-link :to="{ name: 'faq'}">Veel gestelde vragen</router-link>
                </b-nav-item>

                <hr class="d-block d-md-none">

                <li v-if="!isUserLoggedIn">
                    <router-link
                    :to="{ name: 'login'}"
                    class="nav-link">
                    Inloggen
                    </router-link>
                </li>
                <li v-if="!isUserLoggedIn">
                    <router-link
                    :to="{ name: 'register'}"
                    class="nav-link">
                    Registreren
                    </router-link>
                </li>

                <li v-if="isUserLoggedIn" class="nav-item d-block d-md-none">
                    <router-link
                    :to="{ name: 'account'}"
                    class="nav-link"
                    >Mijn gegevens</router-link>
                </li>
                <li v-if="isUserLoggedIn" class="nav-item d-block d-md-none">
                    <router-link
                    :to="{ name: 'cart'}"
                    class="nav-link">Winkelwagen
                    </router-link>
                </li>
                <li v-if="isUserLoggedIn" class="nav-item d-block d-md-none">
                    <router-link
                    :to="{ name: 'logout'}"
                    class="nav-link">
                        Uitloggen
                    </router-link>
                </li>
            </b-navbar-nav>
            <hr class="d-block d-md-none">
            <b-navbar-nav>
                <li class="nav-item">
                    <router-link :to="{ name: 'home'}" class="nav-link">
                    UITLEENDIENST ERFGOED
                    </router-link>
                </li>
            </b-navbar-nav>
            <b-navbar-nav class="ml-md-auto">
                <b-nav-item href="mailto:uitleendienst@faro.be" class="ml-md-auto">
                    CONTACTEER ONS
                </b-nav-item>
            </b-navbar-nav>
        </b-collapse>
  </b-navbar>
</template>
<style>
#logo {
    height:  25px;
}
</style>
<script>
import WarehouseService from '@/services/WarehouseService.js'
import AuthorizationService from '@/services/AuthorizationService'

export default {
    data () {
        return {
            warehouses: {
                Collection: []
            },
            localSearchValue: '',
            isUserLoggedIn: false
        }
    },
    mounted () {
        this.fetchWarehouses()
        this.isUserLoggedIn = AuthorizationService.isUserLoggedIn()
    },
    methods: {
        async fetchWarehouses () {
            this.warehouses = await WarehouseService.getWarehouses()
        },
        setWarehouse (warehouse) { // if we have items in cart, show a warning that cart will be emptied if user clicks OK
            if (this.$store.getters.cart.items.length > 0) {
                this.showChangeWarehousePopup(warehouse)
            } else {
                WarehouseService.setWarehouse(warehouse)
                this.$router.push({ name: 'products' })
            }
        },
        getCartItems () {
            return this.$store.getters.cart
        }
    },
    watch: {
        '$store.getters.token': function (newVal, oldVal) {
            this.isUserLoggedIn = AuthorizationService.isUserLoggedIn()
            this.fetchWarehouses()
        }
    }
}

</script>



// WEBPACK FOOTER //
// src/components/Template/HeaderTop.vue